module.exports = __webpack_public_path__ + "img/39.dd5f66b6.webp";